import { makeStyles, Switch } from "@material-ui/core";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { useRecoilState, useRecoilValue } from "recoil";
import { flightHistoryTooltipControllerState, flightHistoryWindowState } from "../../store/FlightHistoryState";
import { useMapColorState } from "../../store/MapColorState";
import { mapContentsVisibleWithID, MAP_ID_FLIGHT_HISTORY } from "../../store/MapContentsState";
import { deepCopy } from "../../utils/FPEUtils";

const useStyles = makeStyles(() => ({
  controller: {
    padding: 5,
    position: 'absolute',
    bottom: 15,
    right: 55,
    backgroundColor: '#FFFFFF',
    zIndex: 100,
    border: 'solid 1px',
    borderRadius: 10
  },
  forGoogleMap: {
    bottom: 28,
  },
  row: {
    display: 'flex',
    alignItems: 'center'
  },
  label: {
    width: 110,
    textAlign: 'left'
  }
}));

const FlightHistoryTooltipController = () => {
  const {t} = useTranslation();
  const classes = useStyles();
  const [state, setState] = useRecoilState(flightHistoryTooltipControllerState);
  const flightHistoryVisible = useRecoilValue(mapContentsVisibleWithID(MAP_ID_FLIGHT_HISTORY));
  const flightHistoryWindow = useRecoilValue(flightHistoryWindowState);
  const {isGoogleMap} = useMapColorState();

  const hidden = !flightHistoryVisible || flightHistoryWindow.length === 0;

  const handleOnChange = event => {
    setState(prev => {
      const newData = deepCopy(prev);
      newData.find(d => d.name === event.target.name).visible = event.target.checked;
      return newData;
    })
  }

  return (
    <div className={clsx(classes.controller, isGoogleMap && classes.forGoogleMap)} hidden={hidden}>
      {
        state.filter(s => s.enabled).map(s => {
          return (
            <div className={classes.row} key={s.name}>
              <div className={classes.label}>{t(s.name)}</div>
              <Switch checked={s.visible} onChange={handleOnChange} name={s.name} size="small" color="primary"></Switch>
            </div>
          )
        })
      }
    </div>
  )
}

export default FlightHistoryTooltipController;